<template>
  <nav :aria-label="$t('aria_labels.meta_navigation')">
    <ul class="flex w-full items-center justify-end gap-6 router-link">
      <li v-for="{ page } in meta" :key="page.id">
        <NuxtLink
          :to="page.url"
          :target="$useIsExternalUrl(page.url) ? '_blank' : '_self'"
          class="
            text-grey-300 transition-colors duration-300 ease-in-out typo-subtitle
            hover:text-primary-900
          "
        >
          {{ page.title }}
        </NuxtLink>
      </li>

      <!-- LANG SWITCHER -->
      <li>
        <LangSwitcher />
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
const globals = inject(GlobalsKey, null)
const meta = computed(() => globals?.value.meta?.tree)
</script>
